<!--
 * @Description: 潜在客户信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-07-14 18:14:53
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card title="基本信息">
      <dc-form-item label="客户代码">
        <CosInput v-model:value.trim="form.customerNumber" :maxlength="50" placeholder="请输入" view />
      </dc-form-item>
      <dc-form-item label="客户名称">
        <CosInput v-model:value.trim="form.customerName" :maxlength="50" placeholder="请输入" view/>
      </dc-form-item>
      <dc-form-item label="客户详细地址">
        <CosInput v-model:value.trim="form.customerAddress" :maxlength="50" placeholder="请输入" view />
      </dc-form-item>
      <dc-form-item label="关联访客计划">
        <CosInput v-model:value.trim="form.visitPlanTitle" :maxlength="50" placeholder="请输入" view />
      </dc-form-item>
      <dc-form-item label="创建人">
        <CosInput v-model:value.createByName="form.createByName" :maxlength="50" placeholder="请输入" view />
      </dc-form-item>
      <dc-form-item label="签到时间">
        <CosInput v-model:value.trim="form.signInTime" :maxlength="50" placeholder="请输入" view/>
      </dc-form-item>
      <dc-form-item label="备注" :span="12">
        <CosTextarea v-model:value.trim="form.comment" placeholder="请输入" view />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="附件信息">
      <dc-form-item label="附件" :span="24">
        <UploadFile v-model:value="form.fileId" valueType="array" :disabled="true"></UploadFile>
      </dc-form-item>
    </dc-layout-card>
  </a-form>
  <cos-footer-button :hideOk="true"> </cos-footer-button>
</template>
<script setup lang="ts">
import { watch, ref, PropType } from 'vue'
import UploadFile from '@/components/UploadFile'
const form = ref()
const props = defineProps({
  data: {
    type: Object as PropType<any>
  }
})
watch(
  () => props.data,
  (v, prev) => {
    console.log('props.data: ', props.data)
    form.value = props.data
  },
  { immediate: true }
)
// onMounted(() => {
// })
</script>
<script lang="ts">
export default { name: 'PotentialBaseMessage' }
</script>
<style lang="scss"></style>
